module.exports = __webpack_public_path__ + "img/lide.e14bf5f8.png";